import { Injectable, computed, inject, signal } from '@angular/core';
import { ConfigService } from '@app/core/config/config.service';

export interface ServerErrorModalState {
  visible: boolean;
  text: string;
  buttonLabel: string;
}

const DEFAULT_BUTTON_LABEL = 'Aceptar'; // Fallback cuando no hay Transloco
const DEFAULT_STATE: ServerErrorModalState = {
  visible: false,
  text: '',
  buttonLabel: DEFAULT_BUTTON_LABEL,
};

@Injectable({ providedIn: 'root' })
export class ServerErrorModalService {
  private readonly config = inject(ConfigService);
  private readonly state = signal<ServerErrorModalState>(DEFAULT_STATE);

  readonly visible = computed(() => this.state().visible);
  readonly text = computed(() => this.state().text);
  readonly buttonLabel = computed(() => this.state().buttonLabel);

  show(config: { text: string; buttonLabel?: string }): void {
    // Modo mock (revisión de maquetas): suprimimos todos los modales de error
    // porque no hay backend real y los errores esperables son ruido.
    if (this.config.isMockBackend) return;
    this.state.set({
      visible: true,
      text: config.text,
      buttonLabel: config.buttonLabel ?? DEFAULT_BUTTON_LABEL,
    });
  }

  hide(): void {
    this.state.set(DEFAULT_STATE);
  }
}
